/* Place any custom JS in this file. */

/*
  Globo Product Options — swatch rail
  ------------------------------------
  Turns a tall grid of image swatches into a two-row, horizontally scrolling
  rail with prev/next controls.

  Opt in per option-set element by typing a class into the app's
  "HTML class" field (Advanced Settings): oi-swatch-rail

  The app renders into #gb-variants asynchronously and re-renders when options
  change, so we observe the container rather than binding on load.
*/
(function () {
  window.__oiRailLoaded = true;

  var RAIL_SELECTOR = '.oi-swatch-rail';
  var TRACK_SELECTOR = '.gpo-ov-wrapper';

  var ARROW = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">' +
    '<path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.5" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function button(direction, label) {
    var el = document.createElement('button');
    // The app renders inside the product form — without this, a click submits it.
    el.type = 'button';
    el.className = 'oi-rail__btn oi-rail__btn--' + direction;
    el.setAttribute('aria-label', label);
    el.innerHTML = ARROW;
    return el;
  }

  function updateControls(track, prev, next) {
    // Sub-pixel widths mean scrollLeft rarely lands exactly on the maximum.
    var max = track.scrollWidth - track.clientWidth;
    var atStart = track.scrollLeft <= 1;
    var atEnd = track.scrollLeft >= max - 1;
    var noOverflow = max <= 1;

    prev.disabled = atStart;
    next.disabled = atEnd;
    prev.hidden = noOverflow;
    next.hidden = noOverflow;
  }

  function scrollByPage(track, sign) {
    // Just under a full viewport keeps a column of context across the jump.
    track.scrollBy({ left: sign * track.clientWidth * 0.85, behavior: 'smooth' });
  }

  function revealSelected(track) {
    var checked = track.querySelector('input:checked');
    if (!checked) return;

    var swatch = checked.closest('.gpo-swatches') || checked.parentElement;
    if (!swatch) return;

    // scrollIntoView would also scroll the page; move only the rail.
    var offset = swatch.offsetLeft - (track.clientWidth - swatch.offsetWidth) / 2;
    track.scrollLeft = Math.max(0, offset);
  }

  function init(rail) {
    var track = rail.querySelector(TRACK_SELECTOR);
    if (!track || track.dataset.oiRail === 'true') return;
    track.dataset.oiRail = 'true';

    var wrapper = document.createElement('div');
    wrapper.className = 'oi-rail';
    track.parentNode.insertBefore(wrapper, track);

    var prev = button('prev', 'Previous swatches');
    var next = button('next', 'Next swatches');

    wrapper.appendChild(prev);
    wrapper.appendChild(track);
    wrapper.appendChild(next);

    prev.addEventListener('click', function () { scrollByPage(track, -1); });
    next.addEventListener('click', function () { scrollByPage(track, 1); });

    var queued = false;
    function sync() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        updateControls(track, prev, next);
      });
    }

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    // Swatch images load lazily, so scrollWidth keeps growing after first paint.
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(sync).observe(track);
    }

    revealSelected(track);
    updateControls(track, prev, next);
  }

  function scan() {
    document.querySelectorAll(RAIL_SELECTOR).forEach(init);
  }

  function watch() {
    var queued = false;

    /*
      The app's placement is "above an HTML element", so it injects as a sibling
      of #gb-variants rather than a child — watching that div sees nothing.
      Watch the document instead, debounced, and let the dataset flag in init()
      make re-scans cheap and idempotent (our own inserts re-trigger this).
    */
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        scan();
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      // The app sometimes sets classes after inserting its skeleton, so a
      // childList-only observer can miss the element entirely.
      attributes: true,
      attributeFilter: ['class']
    });

    scan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
